export class ScrollPercent {
  initDiff: number = 0;

  init() {
    const windowHeight = this.getWindowHeight();
    const docHeight = this.getDocHeight() - windowHeight;
    this.initDiff = (windowHeight / docHeight) * 100;
    //console.log('Difference : ' + this.initDiff);
    return this.percent();
  }

  percent() {
    const windowHeight = this.getWindowHeight();
    const docHeight = this.getDocHeight() - windowHeight;
    const scrollPosition = this.getScrollPosition();
    const result =
      ((scrollPosition + windowHeight) / docHeight) * 100 - this.initDiff;

    // console.log('Window Height : ' + windowHeight);
    //   console.log('Document Height : ' + docHeight);
    //  console.log('Scroll Position : ' + scrollPosition);

    return Math.floor(result);
  }

  getScrollPosition() {
    return window.pageYOffset !== undefined
      ? window.pageYOffset
      : (document.documentElement || document.body.parentNode || document.body)
          .scrollTop;
  }

  getWindowHeight() {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      0
    );
  }

  getDocHeight() {
    return Math.max(
      document.body.scrollHeight || 0,
      document.documentElement.scrollHeight || 0,
      document.body.offsetHeight || 0,
      document.documentElement.offsetHeight || 0,
      document.body.clientHeight || 0,
      document.documentElement.clientHeight || 0,
    );
  }
}


